module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatter"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }), _c('div', {
    staticClass: "title-frontMatter"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("She’s sexy, successful... and PREGNANT!")])]), _vm._v(" "), _c('div', {
    staticClass: "p-c-br"
  }, [_c('span', [_vm._v("Relax and enjoy our fabulous series about "), _c('br'), _vm._v("spirited women and gorgeous men, whose "), _c('br'), _vm._v("passion results in pregnancies...sometimes "), _c('br'), _vm._v("unexpected! Of course, the birth of a baby is "), _c('br'), _vm._v("always a joyful event, and we can guarantee that "), _c('br'), _vm._v("our characters will become besotted moms and "), _c('br'), _vm._v("dads—but what happened in those nine "), _c('br'), _vm._v("months before?")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-c-br"
  }, [_c('span', [_vm._v("Share the surprises, emotions, dramas and "), _c('br'), _vm._v("suspense as our parents-to-be come to terms "), _c('br'), _vm._v("with the prospect of bringing a new little life into "), _c('br'), _vm._v("the world.... All will discover that the business of "), _c('br'), _vm._v("making babies brings with it the most special "), _c('br'), _vm._v("love of all...")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-c-br"
  }, [_c('span', [_vm._v("Look out next month for our final arrival—"), _c('br'), _vm._v("a Christmas baby—in "), _c('br'), _c('strong', {
    staticClass: "b"
  }, [_vm._v("The Yuletide Child")]), _vm._v(" (#2070) "), _c('br'), _vm._v("by Charlotte Lamb")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6113f01b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459252165_fm02.vue
// module id = 63
// module chunks = 0